import(/* webpackMode: "eager" */ "/home/oreetiene/test.adi-mag.ro/app/(otherPages)/politica-cookies/page.jsx");
